import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { MultiDepositTab } from './MultiDepositTab/MultiDepositTab';
import { MultiDepositTabState } from './MultiDepositTab/MultiDepositTab.state';
import { PaymentMethodTab } from './PaymentMethodTab/PaymentMethodTab';
import { DepositFinalView } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/depositFinalView/DepositFinalView';
import { DepositFailure } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/depositFailure/DepositFailure';
import { YaspaDeposit } from 'src/domains/players/webview/components/WithdrawAndDeposit/yaspa/YaspaDeposit';
import { RealexTab } from './RealexTab/RealexTab';
import { PaysafeTab } from './PaysafeTab/PaysafeTab';
interface PropsType {
    isSignup: boolean;
}

export const MultiDepositJourney = observer('MultiDepositJourney', ({ isSignup }: PropsType): JSX.Element => {
    const common = useCommon();

    const [state] = useState(() => new MultiDepositTabState(common, isSignup));

    const renderContent = (): JSX.Element => {
        switch (state.stepsState.step.type) {
            // Step 1: Choose amount
            case 'set-amount':
                return (
                    <MultiDepositTab
                        state={state}
                        isSignup={isSignup}
                    />
                );

            // Step 2: Select payment method
            case 'select-payment-method':
                return (
                    <PaymentMethodTab
                        state={state}
                        isSignup={isSignup}
                    />
                );

            // Step 3a: Realex loader
            case 'realex-loader':
                return (
                    <RealexTab
                        amount={state.stepsState.step.amount}
                        stepsState={state.stepsState}
                        isSignup={isSignup}
                        errorMessagesState={state.errorMessagesState}
                    />
                );

            // Step 3b: Paysafe loader (Apple Pay)
            case 'paysafe-loader':
                return (
                    <PaysafeTab
                        amount={state.stepsState.step.amount}
                        stepsState={state.stepsState}
                        isSignup={isSignup}
                        errorMessagesState={state.errorMessagesState}
                    />
                );

            // Step 3c: Yaspa iframe
            case 'iframe-view-yaspa':
                return (
                    <YaspaDeposit
                        src={state.stepsState.step.url}
                        onMessage={state.stepsState.redirectFromYaspaIframe}
                        yaspaView={state.stepsState.step.yaspaView}
                        accountHelperMail={state.accountHelperMail}
                        isSignup={isSignup}
                        hideDepositSuccess={state.hideDepositSuccess}
                    />
                );

            // Step 4a: Final success view
            case 'final-view':
                return (
                    <DepositFinalView
                        transactionId={state.stepsState.step.transactionId}
                        isSignup={isSignup}
                        accountHelperMail={state.accountHelperMail}
                        hideDepositSuccess={state.hideDepositSuccess}
                        paymentProvider='realex'
                    />
                );

            // Step 4b: Failure view
            case 'failure-view':
                return (
                    <DepositFailure
                        isSignup={isSignup}
                        issueType={state.stepsState.step.failureType}
                        accountHelperMail={state.accountHelperMail}
                    />
                );
        }
    };

    return <>{renderContent()}</>;
});
